import {
  MapMetric,
  PoleWithPosition,
} from '../../../../../../../../api/theHive/redeProto/types';
import { metricColor, metricValueLabel } from '../../mapMetrics';
import { List, MetricBadge, Name, Row, Sub } from './styles';

interface PoleListProps {
  poles: PoleWithPosition[];
  metric: MapMetric;
  selectedPole: PoleWithPosition | undefined;
  onSelect: (pole: PoleWithPosition) => void;
}

export function PoleList({
  poles,
  metric,
  selectedPole,
  onSelect,
}: PoleListProps): JSX.Element {
  return (
    <List>
      {poles.map((pole) => (
        <Row
          key={pole.poleId}
          type="button"
          selected={selectedPole?.poleId === pole.poleId}
          onClick={() => onSelect(pole)}
        >
          <span>
            <Name>{pole.name ?? pole.city}</Name>
            <br />
            <Sub>
              {pole.uf} · {pole.region ?? '—'}
            </Sub>
          </span>
          <MetricBadge color={metricColor(pole, metric)}>
            {metric === 'classification'
              ? (pole.classification ?? '—').toUpperCase()
              : metricValueLabel(pole, metric)}
          </MetricBadge>
        </Row>
      ))}
    </List>
  );
}
